import { HowLongToPayOffDebt } from 'src/types/inputs';
import { CardsMarketplaceOffer } from 'src/types/marketplace';

import { MethodologyPoints } from '../constants';
import { calculateAnnualFeesScore, calculateScore } from './shared';
import { CalculatePoints, Question } from './types';
import { CalculateMethodology } from '../utils';

const {
  THIRTEEN_POINTS,
  EIGHT_POINTS,
  FIVE_POINTS,
  THREE_POINTS,
  TWO_POINTS,
  ZERO_POINTS,
} = MethodologyPoints;

export const calculateHowLongPayOffScore: CalculatePoints = (
  { howLongToPayOffDebt },
  offer: CardsMarketplaceOffer
) => {
  const offerIntroTime = offer?.details?.purchase_intro_time;
  if (!offerIntroTime) {
    return ZERO_POINTS;
  }

  if (howLongToPayOffDebt === HowLongToPayOffDebt.LessThan18Months) {
    if (offerIntroTime >= 21) {
      return THREE_POINTS;
    }
    if (offerIntroTime >= 18) {
      return FIVE_POINTS;
    }
    if (offerIntroTime >= 15) {
      return THIRTEEN_POINTS;
    }
    if (offerIntroTime >= 12) {
      return EIGHT_POINTS;
    }
    if (offerIntroTime >= 1) {
      return FIVE_POINTS;
    }
  }

  if (howLongToPayOffDebt === HowLongToPayOffDebt.MoreThan18Months) {
    if (offerIntroTime >= 21) {
      return THIRTEEN_POINTS;
    }
    if (offerIntroTime >= 18) {
      return EIGHT_POINTS;
    }
    if (offerIntroTime >= 15) {
      return FIVE_POINTS;
    }
    if (offerIntroTime >= 12) {
      return THREE_POINTS;
    }
    if (offerIntroTime >= 1) {
      return TWO_POINTS;
    }
  }

  return ZERO_POINTS;
};

const QUESTIONS: Question[] = [
  {
    availablePoints: THIRTEEN_POINTS,
    calculate: calculateHowLongPayOffScore,
  },
  {
    availablePoints: THIRTEEN_POINTS,
    calculate: calculateAnnualFeesScore,
  },
];

const getBigPurchaseScore: CalculateMethodology = (answers, offer) =>
  calculateScore(answers, offer, QUESTIONS);

export default getBigPurchaseScore;
